
import { defineComponent } from 'vue'

import type { Route } from 'vue-router'
import { PackageType } from '~/types/types'

interface SidebarSubButton {
  id: string
  label: string
  activeValue: string
  path: Partial<Pick<Route, 'name' | 'params' | 'query'>>
  icon?: string
  count?: number
}

interface SidebarButton extends SidebarSubButton {
  subButtons?: SidebarSubButton[] | null
}

export default defineComponent({
  name: 'UICategorySelector',
  data() {
    return { PackageType }
  },
  props: {
    buttons: {
      type: Array as () => SidebarButton[],
      default: () => []
    },
    activeValues: {
      type: Array as () => string[],
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
})
